<template>
  <div>
    <KTCard ref="preview" v-bind:title="'Edit'">
      <template v-slot:title>
        <h3 class="card-label">
          {{ $t("AUDIT_REVIEW") }}
        </h3>
      </template>
      <template v-slot:body>
        <b-row>
          <StockInfoPanels
            v-if="!firstLoader"
            :storeName="stockAudit.storeName"
            :forDate="stockAudit.forDate"
            :userName="stockAudit.userName"
          >
          </StockInfoPanels>
          <b-col :sm="12">
            <StockAuditItemsPreviewTable
              v-if="!firstLoader"
              :items="stockAudit.items"
              :storeId="stockAudit.storeId"
              :stockAuditId="stockAudit.id"
              :editableLots="true"
            >
            </StockAuditItemsPreviewTable>
          </b-col>
        </b-row>
        <b-form>
          <SkeletonLoaderMain :visible="firstLoader"></SkeletonLoaderMain>
          <v-overlay :value="!firstLoader && isLoadingStock == true">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div
          v-show="_.size(errors) > 0"
          role="alert"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="example-tools justify-content-center">
          <BackButton></BackButton>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { FETCH_STOCK_AUDIT } from "@/modules/stock/store/stock.module";
import StockInfoPanels from "@/modules/stock/components/StockInfoPanels.vue";
import StockAuditItemsPreviewTable from "@/modules/stock/components/audits/StockAuditItemsPreviewTable.vue";

import KTCard from "@/view/content/Card.vue";
import { mapGetters, mapState } from "vuex";

export default {
  mixins: [],
  data() {
    return {
      errors: {},
      firstLoader: true,
      stockAudit: {}
    };
  },
  components: {
    KTCard,
    StockInfoPanels,
    StockAuditItemsPreviewTable
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock audit review", route: { name: "stock-audit-review" } }
    ]);

    vm.getStockAudit();
  },
  computed: {
    ...mapGetters(["isLoadingStock", "currentUser"]),
    ...mapState({
      errors: state => state.auth.errors
    })
  },
  methods: {
    getStockAudit() {
      let vm = this;
      let id = this.$route.params.id;
      this.$store
        .dispatch(FETCH_STOCK_AUDIT, id)
        .then(data => {
          // vm.$notify({
          //   group: "notify",
          //   type: "success",
          //   title: "<i class='flaticon2-checkmark'></i> Success",
          //   text: data.message
          // });
          vm.firstLoader = false;
          vm.$nextTick(function() {
            vm.stockAudit = data.data;
          });
        })
        .catch(response => {
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-audits-list" });
          }
        });
    }
  }
};
</script>
